import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Switch from 'react-toolbox/lib/switch';
import styles from './ThemedSwitch.css';

const ThemedSwitch = ({ color, className, ...props }) => {
  return (
    <Switch
      {...props}
      className={classnames(className, styles[color])}
      theme={styles}
    />
  );
};
ThemedSwitch.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};
export default ThemedSwitch;



// WEBPACK FOOTER //
// ./src/App/account/components/ThemedSwitch/index.js